<template>
	<div class="header-icon logout-icon">
		<button @click="logout">
			<font-awesome-icon icon="lock" />
			<p>Log Out</p>
		</button>
	</div>
</template>

<script>
	import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
	import { mapActions } from 'vuex'

	export default {
		name: 'LogOutIcon',
		components: {
			FontAwesomeIcon
		},
		methods: {
			...mapActions('authmodule', [
				'logout'
			])
		}
	}
</script>

<style lang="scss" scoped>
	button {
		border: 0;
		background: 0;
		cursor: pointer;
		padding: 0;
		text-align:center;
	}

		button:hover {
			p

	{
		text-decoration: underline;
	}
	}
</style>
